import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useRef, useState } from 'react';
import {
  updateSiteProcess,
  getSiteProcessDetail
} from '../../../../apicalls/attendanceManages';
import { TSelectItem } from '../../../../types/common';
import { checkResData } from '../../../../utils/common';
import {
  UseFormGetValues,
  UseFormReset,
  UseFormSetValue
} from 'react-hook-form';
import { createSiteProcessAndSiteTaskEmployeeList } from '../../../../utils';
import { TEditAttendancForm } from '../../../../types/attendancManage';
import { getVendorList } from '../../../../apicalls/getVendorDetails';
import { createGanttResourceAndEvent } from '../../../../utils/attendancePage';
import { useRecoilState } from 'recoil';
import {
  attendanceAssignTotallOfDate,
  attendanceGanttData
} from '../../../../GlobalState';

export type Props = {
  setIsOpen: Dispatch<boolean>;
  id: number;
  getValues: UseFormGetValues<any>;
  setValue: UseFormSetValue<any>;
  reset: UseFormReset<any>;
  isOpen: boolean;
  constructId: number;
  setIsLoadingGantt: Dispatch<boolean>;
};

export const useHooks = (props: Props) => {
  const {
    setIsOpen,
    getValues,
    reset,
    isOpen,
    id,
    setValue,
    constructId,
    setIsLoadingGantt
  } = props;

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);

  const [, setInitialGanttData] = useRecoilState(attendanceGanttData);
  const [, setAssignTotallOfDate] = useRecoilState(
    attendanceAssignTotallOfDate
  );

  // 削除モーダル用
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  // 削除モーダルボタン押下時のハンドラ
  const handleDeleteSubmit = () => {
    setIsOpenDeleteModal(true);
  };

  // 工程編集の処理
  const update = (form: TEditAttendancForm) => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;
    setIsLoadingGantt(true);

    updateSiteProcess(
      form.id,
      form.business_type.value,
      form.user_id?.value ? form.user_id.value : 0,
      form.partner_id?.value ? form.partner_id.value : 0
    ).then((resData: any) => {
      checkResData(resData, enqueueSnackbar)
        .then(async (data: any) => {
          if (data) {
            setIsOpen(false);
            const { resources, events, attendanceManageEventList } =
              await createGanttResourceAndEvent(
                constructId,
                enqueueSnackbar,
                getValues('start_date'),
                getValues('end_date')
              );
            setAssignTotallOfDate(attendanceManageEventList);
            setInitialGanttData({
              resources,
              events
            });
          }
        })
        .finally(() => {
          isSubmitable.current = true;
          setIsLoadingGantt(false);
        });
    });
  };

  // キャンセル時の処理
  const cancelUpdate = () => {
    setIsOpen(false);
  };

  const [selectBusinessType, setSelectBusinessType] = useState({
    label: '--',
    value: 0
  });

  // 担当者選択リスト
  const [employeeList, setEmployeeList] = useState<TSelectItem[]>([]);
  // 企業名選択リスト
  const [partnerList, setPartnerList] = useState<TSelectItem[]>([]);

  // radioボタンの設定
  const businessTypeList: TSelectItem[] = [
    { label: '--', value: 0 },
    { label: '自社', value: 1 },
    { label: '協力会社', value: 2 }
  ];

  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  // モーダルを開く時に初期値を空に
  useEffect(() => {
    if (isOpen) {
      // 担当者選択プルダウン
      createSiteProcessAndSiteTaskEmployeeList(
        constructId,
        enqueueSnackbar
      ).then(employeeList => {
        setEmployeeList(employeeList);
      });

      getVendorList().then(resData => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          const dataList = data.data;
          const tmpList: TSelectItem[] = [{ value: 0, label: '--' }];
          if (dataList && dataList.length > 0) {
            dataList.map((item: any) => {
              tmpList.push({
                label: item.name,
                value: item.id
              });
            });
            setPartnerList(tmpList);
          }
        });
      });

      // オープン時に送信可能にする
      isSubmitable.current = true;
    } else {
      setValue('id', 0);
      setValue('business_type', { value: 0, label: '--' });
      setValue('user_id', { value: 0, label: '--' });
      setValue('partner_id', { value: 0, label: '--' });
      setEmployeeList([]);
      setPartnerList([]);
    }
  }, [isOpen]);

  useEffect(() => {
    if (employeeList.length > 0 && partnerList.length > 0) {
      // 工程詳細を取得してフォームに表示する
      getSiteProcessDetail(id).then(resData => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          if (data) {
            const result: any = data.data;
            const selectedBusinessType = businessTypeList.filter(
              i => i.value == result.business_type
            );

            setSelectBusinessType({
              value: result.business_type,
              label: selectedBusinessType[0].label
            });

            setValue('id', result.id);
            setValue('business_type', {
              value: result.business_type,
              label: selectedBusinessType[0].label
            });

            if (result.business_type == 1) {
              setValue('user_id', {
                value: result.user_id,
                label: result.user_name
              });
              setValue('partner_id', { value: 0, label: '--' });
            } else {
              setValue('user_id', { value: 0, label: '--' });
              setValue('partner_id', {
                value: result.partner_id,
                label: result.partner_name
              });
            }
          }
        });
      });
    }
  }, [employeeList.length, partnerList.length]);

  return {
    update,
    cancelUpdate,
    businessTypeList,
    employeeList,
    partnerList,
    isOpenDeleteModal,
    setIsOpenDeleteModal,
    handleDeleteSubmit,
    selectBusinessType,
    setSelectBusinessType
  };
};
